export default __webpack_public_path__ + "static/media/Resume.453586b0.pdf";